export const getSection = type => {
    if (type.includes('competition')) return 'competition'
    else if (type.includes('parity')) return 'parity'
    else if (type.includes('packages')) return 'packages'
    else if (type.includes('config-panel')) return 'config-panel'
    else if (type.includes('schedulers')) return 'schedulers'
    else if (type.includes('report-settings')) return 'report'
    else if (type.includes('notifications')) return 'notifications'
    else return 'overview'
}